<template>
  <div id="confirm-modal" class="editor-modal">
    <form @submit="confirm" >
      <div class="title">
        <i class="fa-light fa-exclamation-circle"></i>
        <h2 v-html="title"></h2>
      </div>
      <p class="text-muted" v-html="description"></p>
      <button v-if="thirdOption" class="btn btn-md third-option" :class="thirdColorBtnPrimary ? ' btn-primary' : ' btn-secondary'"  v-html="thirdOptionText || 'Ok'"  @click="thirdOptionClick" :disabled="waiting"></button>
      <div class="footer">
        <button
            ref="focus"
            type="submit"
            class="btn btn-md btn-primary"
            @click="confirm"
            v-html="confirmButtonText || 'Ok'"
          >
          </button>
        <button
          type="reset" 
          v-if="!hideCancelButton"
          class="btn btn-md btn-secondary"
          @click="cancelClick"
          v-html="cancelButtonText || $t('confirm-modal.cancel')"
        >
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
 data () {
			return {
			waiting: false				
			}
		},
  props: {
    title: String,
    description: String,
    confirmButtonText: String, 
    cancelButtonText: String, 
    onConfirm: Function,
    hideCancelButton: Boolean,
    onCancel: Function,
    thirdOption: Boolean,
    thirdOptionText: String,
    onThirdOptionClick: Function,
    thirdColorBtnPrimary: Boolean
  },
  computed: {},
  methods: {
    confirm(evt) {
			evt.preventDefault();
      if (this.onConfirm) this.onConfirm()
      this.$emit("close");
    },

    cancelClick(evt){
			evt.preventDefault();
      if (this.onCancel) this.onCancel()
      this.$emit("close");
    },

       thirdOptionClick(evt) {
			evt.preventDefault();
      if (this.onThirdOptionClick) this.onThirdOptionClick()
        this.$emit("close");	
    },
 
  },

  mounted(){
    this.$refs.focus.focus()
  }

};
</script>

<style lang="less">
#confirm-modal form{
  padding: 30px 25px 25px 25px;
  display: flex;
  flex-direction: column;
  .title{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    h2 {
      margin: 0;
    }
    svg{
      font-size: 38px;
      color: var(--flame);
    }
  }
  .third-option{
    margin: 0 25px;
  }
}
</style>
